import type { LiveHelpRequestWithNullableSessionDetails } from '@/components/Worlds/types'

import type { LiveHelpRequestWithSessionDetails } from './types'

export function isLiveHelpRequestWithSessionDetails(
  liveHelpRequest: LiveHelpRequestWithNullableSessionDetails
): liveHelpRequest is LiveHelpRequestWithSessionDetails {
  return liveHelpRequest.session != null
}
